// @ts-nocheck

import { QRActionTypes } from '../types/actions/qr';

const requireQRScan = () => ({
  type: QRActionTypes.REQUIRE_QR_SCAN,
  payload: {},
});

const setQRScanResult = (scan) => ({
  type: QRActionTypes.SET_QR_SCAN_RESULT,
  payload: { scan },
});

const resetQRScanResult = () => ({
  type: QRActionTypes.RESET_QR_SCAN_RESULT,
  payload: {},
});

export default {
  requireQRScan,
  setQRScanResult,
  resetQRScanResult,
};
